import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar, Row, Col } from 'react-bootstrap';

const FailureUnitGauge = ({ data, target }) => {
    let unitVarClass = 'success';
    if (data?.dateFails?.UnitVariation > target)
        unitVarClass = 'danger';

    return (
        <Row className='px-3 ms-2'>
            <Row>
                <Col><span className='p-2 h5 float-start'>Item Failure Rate</span></Col>
                <Col><span className={`p-2 h5 float-end text-${unitVarClass} fw-bold`}>{data?.dateFails?.UnitVariation?.toFixed(2)}%</span></Col>
            </Row>
            <Row>
                <Col sm='12' className="position-relative p-0">
                    <ProgressBar
                        style={{ height: '8px', width: '100%', transform: 'translateY(-6px)' }}
                        variant={unitVarClass}
                        min={0}
                        max={1.6}
                        now={data?.dateFails?.UnitVariation || 0}
                    />
                    <div
                        className="position-absolute top-0 w-100 d-flex justify-content-between text-muted pe-3"
                        style={{ transform: 'translateY(-12px) translateX(-3px)' }}>
                        <span className={`text-${unitVarClass} fw-bolder`}>|</span>
                        <span className={`text-${unitVarClass} fw-bolder`}>|</span>
                        <span className={`text-${unitVarClass} fw-bolder`}>|</span>
                    </div>
                    <div
                        className="position-absolute top-0 w-100 d-flex justify-content-between text-muted pe-3"
                        style={{ transform: 'translateY(10px)' }}>
                        <small>0</small>
                        <small>.75</small>
                        <small>1.5</small>
                    </div>
                </Col>
                {/* <Col sm='2' style={{ transform: 'translateY(-14px)' }} className={`text-${unitVarClass} fw-bold`}>{data?.dateFails?.UnitVariation?.toFixed(2)}%</Col> */}
            </Row>
        </Row>
    )
}

FailureUnitGauge.propTypes = {
    data: PropTypes.object,
    target: PropTypes.number
};
export default memo(FailureUnitGauge);